require('expose-loader?$!expose-loader?jQuery!jquery');
/**
 * webpack is based on top of JavaScript modules. To use old school global scope the best way is to use uglify-loader!script-loader!uglify-loader.
 * better would be if this would only happen on legacy JS
 */

require('../js-lib/jquery-ui-1.12.1.custom/jquery-ui.min.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/jquery-ui-1.12.1.custom/jquery-ui.min.css');
require('uglify-loader!script-loader!uglify-loader!../js-lib/jquery-ui-touch-punch/jquery.ui.touch-punch.min.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/jquery-cookie/jquery.cookie-1.4.0.js');

require('expose-loader?ResponsiveBootstrapToolkit!../js-lib/responsive-bootstrap-toolkit-master/dist/bootstrap-toolkit.min.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/bootstrap-3.3.7/collapse.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/bootstrap-3.3.7/tooltip.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/bootstrap-3.3.7/popover.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/bootstrap-3.3.7/button.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/bootstrap-3.3.7/modal.js');

require('uglify-loader!script-loader!uglify-loader!../js-lib/tooltipster-master/dist/js/tooltipster.bundle.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/tooltipster-master/dist/css/tooltipster.bundle.css');

require('uglify-loader!script-loader!uglify-loader!../js-lib/cnxsteptabs-1.4.1/jquery.cnxsteptabs-1.4.1.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/float-labels/forms-float-labels.custom.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/selectboxit-3.8.1/jquery.selectBoxIt.min.js');

require('uglify-loader!script-loader!uglify-loader!../js-lib/flickity/flickity.pkgd.min.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/flickity/flickity.min.css');

require('uglify-loader!script-loader!uglify-loader!../js-lib/tablesaw/tablesaw.stackonly.js');

require('uglify-loader!script-loader!uglify-loader!../js-lib/colorbox/jquery.colorbox-min.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/colorbox/colorbox.css');

require('uglify-loader!script-loader!uglify-loader!../js-lib/datepicker/timepicker.js');
require('uglify-loader!script-loader!uglify-loader!../js-lib/datepicker/sliderAccess.js');

require('uglify-loader!script-loader!uglify-loader!../js-lib/imask-6.4.2/imask.min.js');

require('uglify-loader!script-loader!uglify-loader!../js/cnx-app.js');
require('uglify-loader!script-loader!uglify-loader!../js/gallery.js');
require('uglify-loader!script-loader!uglify-loader!../js/content-box.js');
require('uglify-loader!script-loader!uglify-loader!../js/course.js');
require('uglify-loader!script-loader!uglify-loader!../js/dialogue.js');
require('uglify-loader!script-loader!uglify-loader!../js/loginbox.js');
require('uglify-loader!script-loader!uglify-loader!../js/profile.js');
require('uglify-loader!script-loader!uglify-loader!../js/tournament.js');
require('uglify-loader!script-loader!uglify-loader!../js/navigation.js');
require('uglify-loader!script-loader!uglify-loader!../js/forms.js');
require('uglify-loader!script-loader!uglify-loader!../js/modal.js');
require('uglify-loader!script-loader!uglify-loader!../js/datepicker.js');
require('uglify-loader!script-loader!uglify-loader!../js/ahv-number-mask.js');
